var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainSnowShowersDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95.87 85.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5f1fb;}.cls-2{fill:#f5b952;}.cls-3,.cls-5,.cls-6,.cls-7{fill:none;stroke:#000;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-3{stroke-width:1.5px;}.cls-4{fill:#b9e4fa;stroke:#231f20;stroke-width:3px;}.cls-5,.cls-7{stroke-width:5px;}.cls-6,.cls-7{stroke-linecap:round;}.cls-6{stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rain-snow-showers-dayAsset 145colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93,59a10.14,10.14,0,0,0-1.94-3.8,9.86,9.86,0,0,0-2.47-2.31,10.52,10.52,0,0,0-4.21-1.57,1,1,0,0,1-.56-.55A10.26,10.26,0,0,0,72.9,44a18.22,18.22,0,0,0-3.62,1,1.08,1.08,0,0,1-1.21-.43,12.26,12.26,0,0,0-4.7-4,14.18,14.18,0,0,0-2.09-.82c-.37-.1-.74-.21-1.12-.29a10.22,10.22,0,0,0-3-.18,12.17,12.17,0,0,0-1.22.14,11.56,11.56,0,0,0-1.18.24l-.13.05a21.36,21.36,0,0,0-4.26,2.1,30,30,0,0,0-3.5,3.46l-.1,0a11.44,11.44,0,0,0-5.29-1.38,9.84,9.84,0,0,0-4.66,1.13A11,11,0,0,0,32,50.09a2.25,2.25,0,0,1-1.38,1.07,11.2,11.2,0,0,0-2.89,1,9.59,9.59,0,0,0-3.63,3.26c-.14.22-.3.43-.43.67a12.18,12.18,0,0,0-1.35,3.53,9,9,0,0,0,0,3.46,10.32,10.32,0,0,0,8.47,8.54,1.16,1.16,0,0,1,1,.87,10.22,10.22,0,0,0,8.48,6.62,10,10,0,0,0,5.85-1,1,1,0,0,1,1.28.33,12.65,12.65,0,0,0,20.63.1,1,1,0,0,1,1.28-.32A10.34,10.34,0,0,0,83.73,72.5a.85.85,0,0,1,.79-.6A10.35,10.35,0,0,0,93,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.92,37.91c-.07,1.54-11.49,2.68-23.87,8.17C26.6,50.27,23.24,53.31,23.24,43A18.73,18.73,0,0,1,42,24.25C52.31,24.25,60.31,29.61,59.92,37.91Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.83,
    y1: 56.21,
    x2: 40.83,
    y2: 60.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "39.44 54.79 40.84 56.19 42.25 54.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.86,
    y1: 66.09,
    x2: 40.86,
    y2: 62.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "42.25 67.5 40.85 66.11 39.44 67.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 45.03,
    y1: 63.78,
    x2: 41.71,
    y2: 61.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "45.49 65.71 45.05 63.79 46.99 63.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.66,
    y1: 58.52,
    x2: 39.98,
    y2: 60.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "36.2 56.58 36.64 58.51 34.69 58.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.66,
    y1: 63.77,
    x2: 39.98,
    y2: 61.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "36.19 65.7 36.64 63.78 34.69 63.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 45.03,
    y1: 58.52,
    x2: 41.71,
    y2: 60.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "45.5 56.59 45.05 58.51 47 58.97"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40.78,
    cy: 61.16,
    r: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.37,
    y1: 56.21,
    x2: 76.37,
    y2: 60.12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "74.97 54.79 76.37 56.19 77.79 54.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.39,
    y1: 66.09,
    x2: 76.39,
    y2: 62.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "77.79 67.5 76.39 66.11 74.97 67.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.56,
    y1: 63.78,
    x2: 77.25,
    y2: 61.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "81.02 65.71 80.58 63.79 82.53 63.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.2,
    y1: 58.52,
    x2: 75.51,
    y2: 60.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "71.73 56.58 72.18 58.51 70.23 58.96"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.19,
    y1: 63.77,
    x2: 75.51,
    y2: 61.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "71.73 65.7 72.17 63.78 70.22 63.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.56,
    y1: 58.52,
    x2: 77.25,
    y2: 60.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "81.03 56.59 80.58 58.51 82.53 58.97"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76.32,
    cy: 61.16,
    r: 1.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58,52.46c-1.47,3.34-3.11,6.61-4.46,10-1.1,2.78.5,5.45,3.35,6.35a4.42,4.42,0,0,0,2.39-.07c2.77-1,4.23-3.51,3.15-6.26C61.11,59.08,59.48,55.81,58,52.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93,58.42a10,10,0,0,0-1.94-3.79,9.9,9.9,0,0,0-2.47-2.32,10.51,10.51,0,0,0-4.21-1.56c-.21,0-.47-.33-.56-.56A10.27,10.27,0,0,0,72.9,43.43a18.22,18.22,0,0,0-3.62,1A1.08,1.08,0,0,1,68.07,44a12.23,12.23,0,0,0-4.7-4,13.15,13.15,0,0,0-2.09-.82c-.37-.11-.74-.21-1.12-.29a10.24,10.24,0,0,0-3-.19,12.17,12.17,0,0,0-1.22.14,10.62,10.62,0,0,0-1.18.25l-.13,0a21.36,21.36,0,0,0-4.26,2.1,30.81,30.81,0,0,0-3.5,3.46l-.1,0a11.55,11.55,0,0,0-5.29-1.37,9.84,9.84,0,0,0-4.66,1.12A11.06,11.06,0,0,0,32,49.52a2.22,2.22,0,0,1-1.38,1.07,11.2,11.2,0,0,0-2.89,1,9.68,9.68,0,0,0-3.63,3.26c-.14.22-.3.44-.43.68A12.12,12.12,0,0,0,22.28,59a9.1,9.1,0,0,0,0,3.47A10.31,10.31,0,0,0,30.74,71a1.18,1.18,0,0,1,1,.87,10.25,10.25,0,0,0,8.48,6.63,10.11,10.11,0,0,0,5.85-1,1,1,0,0,1,1.28.32A12.66,12.66,0,0,0,68,78a1,1,0,0,1,1.28-.33,10.34,10.34,0,0,0,14.46-5.71.84.84,0,0,1,.79-.59A10.35,10.35,0,0,0,93,58.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.77,39A18.84,18.84,0,0,0,23.35,42a18.65,18.65,0,0,0,3.09,10.32"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 42.15,
    y1: 14.23,
    x2: 42.15,
    y2: 6.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 14.23,
    y1: 42.15,
    x2: 6.07,
    y2: 42.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 22.41,
    y1: 22.41,
    x2: 16.64,
    y2: 16.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 67.66,
    y1: 16.64,
    x2: 61.89,
    y2: 22.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 54.63,
    y1: 11.47,
    x2: 58.28,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 11.47,
    y1: 29.67,
    x2: 2.5,
    y2: 26.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 29.28,
    y1: 11.63,
    x2: 25.52,
    y2: 2.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 11.63,
    y1: 55.02,
    x2: 2.71,
    y2: 58.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 81.59,
    y1: 25.52,
    x2: 72.67,
    y2: 29.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainSnowShowersDay);
export default __webpack_public_path__ + "static/media/rain-snow-showers-day.2049dc22f51b775cff957088c336bf31.svg";
export { ForwardRef as ReactComponent };